// Init
import React, { useContext, useState, useEffect, createContext } from "react";
import { initialStoreState, accountStore } from "./initialState";
import { getToken } from "./utilities/auth";
import axios from "axios";
import config from "./config";

// Initializing Create Context Hook
const storeContext = createContext();
const storeUpdateContext = createContext();
const UserContext = createContext();

// We are also initializing useContexts here then we only call these functions where we need that data
export function Store() {
  return useContext(storeContext);
}
export function UpdateStore() {
  return useContext(storeUpdateContext);
}

export const useUser = () => useContext(UserContext);

// Initializing Store Provider
export function StoreProvider({ children }) {
  const token = getToken();
  const [store, setStore] = useState(initialStoreState);
  const [user, setUser] = useState(accountStore);
  const [loadingUser, setLoadingUser] = useState(false);
  const [storedLocations, setStoredLocations] = useState([]);

  const updateStore = (data) => {
    console.log(data, "dataaaaaa");
    setStore((prev) => {
      return {
        ...prev,
        ...data,
      };
    });
  };

  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     const token = getToken();
  //     // eslint-disable-next-line no-console
  //     console.log(token, "token");
  //     if (!token) {
  //       removeToken();
  //     } else {
  //       try {
  //         setLoadingUser(true);
  //         // "https://www.testaccount.devprestigeride.com/api/accounts/auth",
  //         const result = await axios.get(
  //           "https://www.testaccount.devprestigeride.com/api/accounts/auth",
  //           {
  //             withCredentials: true, // Include cookies in the request
  //           }
  //         );

  //         // eslint-disable-next-line no-console
  //         console.log(result, "auth result");

  //         if (result?.data?.success && result?.data?.user) {
  //           const userData = result?.data?.user;
  //           setUser({
  //             account: userData || null,
  //             accountId: userData?._id || null,
  //             accountNumber: userData?.accountNumber || null,
  //             accountStatus: "welcome",
  //           });
  //         } else if (!result?.data?.user) {
  //           removeToken();
  //         }
  //       } catch (error) {
  //         removeToken();
  //         console.error(error, "eeeeee");
  //       } finally {
  //         setLoadingUser(false);
  //       }
  //     }
  //   };

  //   fetchUserData();

  //   // 👇 Add visibility + bfcache detection
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       fetchUserData();
  //     }
  //   };

  //   const handlePageShow = (event) => {
  //     if (event.persisted) {
  //       fetchUserData();
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   window.addEventListener("pageshow", handlePageShow);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //     window.removeEventListener("pageshow", handlePageShow);
  //   };
  // }, []);

  useEffect(() => {
    if (user?.accountId && token) {
      const userStoredLocation = async () => {
        try {
          const result = await axios.get(
            `${config.accountUrl}/api/accounts/get-address`,
            {
              withCredentials: true, // Include cookies in the request
              headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
              },
            }
          );

          console.log(result, "llllllll");
          if (result?.data?.success && result?.data?.data?.length > 0) {
            const address = result.data.data.map((address) => ({
              ...address?.descriptionObject,
              type: address.addressType,
            }));

            setStoredLocations(address);
            return;
          }
          return [];
        } catch (error) {
          console.error(error);
          return [];
        }
      };

      userStoredLocation();
    } else {
      setStoredLocations([]);
    }
  }, [user?.accountId, token]);

  console.log("ssssssss", store);
  console.log("uuuuu", user);
  // Render
  return (
    <storeContext.Provider value={store}>
      <storeUpdateContext.Provider value={updateStore}>
        <UserContext.Provider
          value={{
            user,
            setUser,
            loadingUser,
            setLoadingUser,
            storedLocations,
            setStoredLocations,
          }}
        >
          {children}
        </UserContext.Provider>
      </storeUpdateContext.Provider>
    </storeContext.Provider>
  );
}
